import PropTypes from 'prop-types';
import get from 'lodash/get';
import debounce from 'lodash/debounce';
import { lifecycle, setPropTypes, withHandlers, withStateHandlers } from 'recompose';

export const autoCompletePickerPropTypes = () =>
    setPropTypes({
        id: PropTypes.string.isRequired,
        defaultName: PropTypes.string,
        propsMap: PropTypes.objectOf(PropTypes.string).isRequired,
        updateWidgetJSPropField: PropTypes.func.isRequired,
    });

export const autoCompleteWithStateHandlers = () =>
    withStateHandlers(
        ({ defaultName = '' }) => ({
            loading: false,
            searchText: defaultName,
            data: [],
        }),
        {
            handleLoading: () => (loading = false) => ({ loading }),
            handleSearchText: () => (searchText = '') => ({ searchText }),
            handleData: () => (data = []) => ({ data }),
        },
    );

export const autoCompleteWithHandlerLoadData = (fetchDataCb = () => {}, wait = 300) =>
    withHandlers({
        loadData: ({ loading = false, handleLoading, handleData }) =>
            debounce((searchText = '') => {
                const controller = new AbortController();
                const signal = controller.signal;

                if (loading) {
                    controller.abort();
                }

                handleLoading(false);

                fetchDataCb(searchText, signal)
                    .then(data => {
                        handleData(data);
                        handleLoading(false);
                    })
                    .catch(() => {
                        handleLoading(false);
                    });
            }, wait),
    });

export const autoCompleteWithHandlers = (onNewRequestDefaultKeysCb = () => ({}), isLoadDataInHandleUpdate = false) =>
    withHandlers({
        handleUpdateInput: ({ id, handleSearchText, loadData, updateWidgetJSPropField }) => (searchText = '') => {
            updateWidgetJSPropField(id, { defaultName: searchText });

            handleSearchText(searchText);

            if (isLoadDataInHandleUpdate) {
                loadData(searchText);
            }
        },
        onNewRequest: ({ id, propsMap, updateWidgetJSPropField }) => (data = {}) => {
            updateWidgetJSPropField(
                id,
                Object.entries(propsMap).reduce(
                    (stats, [statName, key]) => ({
                        ...stats,
                        [statName]: get(data, key),
                    }),
                    onNewRequestDefaultKeysCb(data),
                ),
            );
        },
        handleOnClose: ({ id, searchText, updateWidgetJSPropField }) => () => {
            updateWidgetJSPropField(id, { defaultName: searchText });
        },
    });

export const autoCompleteDefaultLifeCycle = (isDidMountLoadData = false) =>
    lifecycle({
        componentDidMount() {
            if (isDidMountLoadData) {
                this.props.loadData();
            }
        },
        componentWillReceiveProps({ defaultName = '' }) {
            if (this.props.defaultName !== defaultName) {
                this.props.handleSearchText(defaultName);
            }
        },
    });



/** WEBPACK FOOTER **
 ** ../src/dash/front/editor/pickers/helpers/autoComplete.js
 **/